import React from 'react';
import HelpTooltip from '../../HelpTooltip/HelpTooltip';

function PhoneHelpTooltip() {
  return (
    <HelpTooltip size="sm" showTitle={false}>
      <article>
        <h6 className="text-info">Phone format</h6>

        <div className="small text-muted mb-3">
          We expect <strong>10 digits</strong>, any non-numeric character will
          be ignored, no need to add +1 country code. Only US phone numbers are
          allowed at the moment, sorry for the inconvenience
        </div>

        <h6 className="small text-muted">Examples</h6>
        <ul className="mb-0">
          <li>1234567890</li>
          <li>(123) 456-7890</li>
          <li>123 456-7890</li>
          <li>123 456 7890</li>
        </ul>
      </article>
    </HelpTooltip>
  );
}

export default PhoneHelpTooltip;
